import axios from 'axios';

const instance = axios.create({
  //baseURL: 'http://admin.regler-sikora.localhost/api/'
  // baseURL: 'http://regler-sikora-admin.zirkusdigitalo.de/api/'
  //baseURL: 'http://regler-sikora-admin.zeitlosentspannen.de/api/'
  baseURL: 'https://admin.regler-sikora.de/admin/api/'
});

export default instance;